import { render, staticRenderFns } from "./FavoritesButton.vue?vue&type=template&id=368352a2&scoped=true&"
import script from "./FavoritesButton.vue?vue&type=script&lang=js&"
export * from "./FavoritesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368352a2",
  null
  
)

export default component.exports